import { styled, Theme } from '@mui/material';

import { FlexibleContent } from './flexible-content';
import { MarkdownContentWithImage } from './markdown-content-with-image-description';

export type flexibelContentProps = {
  headline: string;
  introductionText: string;
  imageData?: {
    image: React.ReactElement;
    alignImage: 'left' | 'right';
  };
  imageDescriptionText: string;
  getAssetUrl: (url: string, assetsUrl?: string | undefined) => string;
  cta: {
    text: string;
    url: string;
  } | null;
};

export const FlexibelContentWithIntro = ({
  headline,
  introductionText,
  imageData,
  imageDescriptionText,
  getAssetUrl,
  cta,
}: flexibelContentProps) => (
  <div>
    <Headline>{headline}</Headline>
    <IntroductionText
      html={introductionText}
      getAssetUrl={getAssetUrl}
    ></IntroductionText>
    <FlexibleContent
      imageData={imageData}
      richtext={{
        data: {
          childMarkdownRemark: { html: imageDescriptionText, headings: [] },
        },
      }}
      getAssetUrl={getAssetUrl}
      markdownSx={(theme: Theme) => ({
        h6: {
          ...theme.typography.h6,
          fontWeight: theme.typography.fontWeightRegular,

          strong: {
            fontWeight: theme.typography.fontWeightMedium,
          },
        },
      })}
    ></FlexibleContent>
  </div>
);

const Headline = styled('h1')(({ theme }) => ({
  ...theme.typography.h1,
  marginBottom: 'var(--spacer-xl)',
  fontWeight: 'var(--font-weight-medium)',
  fontSize: '32px',
  lineHeight: '130%',
  marginTop: 0,

  [theme.breakpoints.up('sm')]: {
    fontSize: '42px',
  },
  [theme.breakpoints.up('md')]: { fontSize: '48px' },
  [theme.breakpoints.up('lg')]: { fontSize: '64px' },
}));

const IntroductionText = styled(MarkdownContentWithImage)(({ theme }) => ({
  [theme.breakpoints.up(0)]: { marginBottom: 'var(--spacer-xl)' },

  h3: {
    ...theme.typography.h3,
    fontWeight: theme.typography.fontWeightRegular,
    margin: 0,

    strong: {
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
}));
